import useExperiment from '@hooks/useExperiment.experiments'

function useNavbarV2() {
  const branchId = useExperiment('navbar-v2', {allowServerSide: true})
  return branchId === 'enabled'
}

export default useNavbarV2
